var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.875H11.375L10.8687 2.45625C10.8338 2.35917 10.7697 2.27525 10.6852 2.21596C10.6008 2.15668 10.5001 2.12491 10.3969 2.125H5.60313C5.39219 2.125 5.20312 2.25781 5.13281 2.45625L4.625 3.875H2.5C1.80937 3.875 1.25 4.43437 1.25 5.125V12.25C1.25 12.9406 1.80937 13.5 2.5 13.5H13.5C14.1906 13.5 14.75 12.9406 14.75 12.25V5.125C14.75 4.43437 14.1906 3.875 13.5 3.875ZM13.625 12.25C13.625 12.3187 13.5688 12.375 13.5 12.375H2.5C2.43125 12.375 2.375 12.3187 2.375 12.25V5.125C2.375 5.05625 2.43125 5 2.5 5H5.41719L5.68437 4.25312L6.04219 3.25H9.95625L10.3141 4.25312L10.5813 5H13.5C13.5688 5 13.625 5.05625 13.625 5.125V12.25ZM8 6C6.61875 6 5.5 7.11875 5.5 8.5C5.5 9.88125 6.61875 11 8 11C9.38125 11 10.5 9.88125 10.5 8.5C10.5 7.11875 9.38125 6 8 6ZM8 10C7.17188 10 6.5 9.32812 6.5 8.5C6.5 7.67187 7.17188 7 8 7C8.82812 7 9.5 7.67187 9.5 8.5C9.5 9.32812 8.82812 10 8 10Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic_camera.35ce34f52550d8f4310d3d0511c3143d.svg";
export { ForwardRef as ReactComponent };